import { apiClient } from './client';

const BASE = '/api/reports/wordpress';

const mapEvent = (event) => ({
  id: String(event.id),
  title: event.title,
  originalTitle: event.original_title,
  slug: event.slug,
  start_date: event.start_date,
  end_date: event.end_date,
  children: event.children || [],
});

/** DigWatch (WordPress) event catalog, read through the backend proxy. */
export const wpApi = {
  getEventsWithChildren: async ({ forceRefresh = false } = {}) => {
    const response = await apiClient.get(`${BASE}/events`, {
      params: forceRefresh ? { force_refresh: true } : undefined,
    });
    return (response.data?.events || []).map(mapEvent);
  },

  getChildEvents: async (eventId, { forceRefresh = false } = {}) => {
    const response = await apiClient.get(`${BASE}/events/${eventId}/children`, {
      params: forceRefresh ? { force_refresh: true } : undefined,
    });
    return response.data?.children || [];
  },
};
